import ReactPixel from "react-facebook-pixel"

export const facebookEventsInit = () => {
  ReactPixel.init("1304009443569152")
  ReactPixel.pageView()
}
